/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Stub_ReadyInputs */

const cs_sms_stub_ready = /** @type {(inputs: Sms_Stub_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vývojový stub — odeslání nevolá reálnou bránu`)
};

const en_sms_stub_ready = /** @type {(inputs: Sms_Stub_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dev stub — sends do not hit a real gateway`)
};

/**
* | output |
* | --- |
* | "Dev stub — sends do not hit a real gateway" |
*
* @param {Sms_Stub_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_stub_ready = /** @type {((inputs?: Sms_Stub_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Stub_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_stub_ready(inputs)
	return cs_sms_stub_ready(inputs)
});